import React, {useState} from 'react';
import RLookUpModal from "../SellFactor/FactorKOL/RLookUpModal";

const FactorRLookUp = ({sendData, setSendData, initialData, componentData, setComponentData,}) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div>

      <>
        <div className={"d-flex align-items-center my-2"}>

          <div style={{flexBasis: '100%'}}
               className={"mx-1 btn btn-secondary"}
               onClick={()=>setIsOpen(true)}
          >
            <>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                   className="bi bi-file-earmark-medical" viewBox="0 0 16 16">
                <path
                  d="M7.5 5.5a.5.5 0 0 0-1 0v.634l-.549-.317a.5.5 0 1 0-.5.866L6 7l-.549.317a.5.5 0 1 0 .5.866l.549-.317V8.5a.5.5 0 1 0 1 0v-.634l.549.317a.5.5 0 1 0 .5-.866L8 7l.549-.317a.5.5 0 1 0-.5-.866l-.549.317V5.5zm-2 4.5a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5zm0 2a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5z"/>
                <path
                  d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2zM9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5v2z"/>
              </svg>
            </>
            <span className={"mx-1"}>{sendData.factorId? ("کد فاکتور:"+sendData.factorId) : "انتخاب فاکتور"}</span>
          </div>

        </div>
      </>
      <>
        {isOpen && <RLookUpModal
          id={initialData.buyFactorRLookUpId}
          callBackDataHandler={(incomingData) => {
            // alert(incomingData)
            console.log(incomingData)

            setSendData({
              factorId: incomingData.na_905,
              tax:incomingData.na_906
            })
            // factorDataSetter({"rLookUpData": incomingData, isOpenModalSelectCarRLookUp: false})
            // setSendData({...sendData, IDKHOD: incomingData})

          }}
          modalHandler={[isOpen, (isOpen) => setIsOpen(isOpen)]}
        />}
      </>
    </div>
  );
};

export default FactorRLookUp;
